import React from 'react';
import { useRef, useEffect, useState, useContext } from 'react';
import { CheckoutContext } from "../lib/CheckoutContext";

export default function CheckoutButton(props) {
  const { setCheckoutOpen, setUiLocation, setPaymentMode } = useContext(CheckoutContext);
  // function handleSubmit() {
  //   const inputId = props.inputId || "credits-input";
  //   const creditsInput = document.getElementById(inputId);
  //   const parameter1Value = creditsInput.value || 5;

  //   // Update the hidden input fields with parameter values
  //   document.getElementById("parameter1").value = parameter1Value;

  //   // Submit the form
  //   document.getElementById("checkoutForm").submit();
  // }

  function openCheckout() {
    // const inputId = props.inputId || "credits-input";
    // const creditsInput = document.getElementById(inputId);
    // const quantityValue = creditsInput.value || quantity;    
    if (props.ui_location) {
      setUiLocation(props.ui_location);
    }    
    // setUiLocation(props.ui_location);
    // setQuantity(quantityValue);
    setPaymentMode("payment");
    // setClientSecret(paymentClientSecret);
    setCheckoutOpen(true);
    // if (!clientSecret) {      
    //   setPaymentMode("payment");
    // }
    // setSelectedPlan("payment");
    // 
  }

  if (props.ui_location == "navbar") {
    return (
      <label id="navbar-checkout" onClick={openCheckout} htmlFor="my-modal-checkout"  className="cursor-pointer inline-flex items-center justify-center w-full px-10 py-1 text-base font-medium text-white transition-all duration-200 bg-emerald-600 border-transparent rounded-xl hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
        Checkout
      </label> 
    )
  }

  return (    
    <button onClick={openCheckout} className="inline-flex items-center justify-center w-full px-10 py-1 text-base font-medium text-white transition-all duration-200 bg-emerald-600 border-transparent rounded-xl hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
      Checkout
    </button>                     
  // <form action="/api/checkout_sessions" method="POST" id="checkoutForm">
  //   <input type="hidden" name="quantity" id="parameter1" value="" />                
  //   <section>
  //     <button
  //       type="button"
  //       role="link"
  //       onClick={handleSubmit}
  //       className="inline-flex items-center justify-center w-full px-10 py-1 text-base font-medium text-white transition-all duration-200 bg-emerald-600 border-transparent rounded-xl hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
  //     >
  //       Checkout
  //     </button>
  //   </section>
  // </form>           
  )
}



//   return (
//     <form onSubmit={handleSubmit}>
//       <section>
//         <input
//           type="text"
//           name="input1" // Add name attribute to identify the input
//           value={formData.input1 || ""}
//           onChange={handleChange}
//           className="text-center h-8 w-full input input-primary input-bordered rounded-none"
//         />
//         <input
//           type="text"
//           name="input2" // Add name attribute to identify the input
//           value={formData.input2 || ""}
//           onChange={handleChange}
//           className="text-center h-8 w-full input input-primary input-bordered rounded-none"
//         />
//         <button
//           type="submit"
//           role="link"
//           className="inline-flex items-center justify-center w-full px-10 py-1 text-base font-medium text-white transition-all duration-200 bg-emerald-600 border-transparent rounded-xl hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
//         >
//           Checkout
//         </button>
//       </section>
//     </form>
//   );
// };

